// extracted by mini-css-extract-plugin
export default {"avatar-group":"wGI8lN","avatar-group_wrap":"hvTOiU","avatar-group__item":"myxq1r"};